export const API_URLS = {
  login: 'usuarios/login',
  usuarios: '/usuarios',
  refreshToken: '/Usuarios/refresh-token',

  pedidos: '/pedidos',
  procesos: '/BlockedProcesses',
  listaProcesos: '/BlockedProcesses/procesos-catalogo',
  archivos: '/BlockedFiles',
  bloquearProceso: `/BlockedProcesses/block`,
  desbloquearProceso: `/BlockedProcesses/unblock`,
  bloquearFile: `/BlockedFiles/block`,
  desbloquearFile: `/BlockedFiles/unblock`,
  nuevoFile: `/BlockedFiles/nuevoFile`,
  verificaArchivo: `/BlockedFiles/verificar-archivo`,
  archivados: `/BlockedFiles/archivados`,
  archivar: `BlockedFiles/archivar`,
  getSalesOrdes :`/SalesOrders/resumen`,
  PedidoExt:`pedido/salesStatusByDate`,
  SalesPedido:`pedido/salesStatusByDate`, 
  PedidoFecha:`Pedido/pedidos`,
  enviaMaximos:`MaxCustomerProduct/upload`,
  resultados:`Results`,


  getProfile: 'Auth/perfil',
  EliminaRol: (id) => `Roles/${id}`,
  detallePedido: (id) => `Pedido/detalle/${id}`,
  HistoriaProceso:(id) =>`BlockedProcesses/Historial/${id}`,
  
  //servicios que se usaran para DME
    layoutByClient: (clientName) => `/chain-formats/${encodeURIComponent(clientName)}`,
    chainsByUserEmail: (email) => `/dmeusers/${encodeURIComponent(email)}/chains`,
    enviaDME: () => '/dmeupload/upload',
    apruebaLimiteDME: () => '/dmeupload/AuthorizeLimitFolio',
    rechazaLimiteDME: () => '/dmeupload/RejectLimitFolio',
    LimiteFoliosPendientes: '/dmeupload/GetLimitPendingFolios',
    ListaPermisos: 'Permisos',
    ActualizaPermisos: 'Permisos/save',
    EliminaPermisos: (id) => `/permisos/${id}`,
    roles: `Roles`,
    GuardaRoles: `Roles`,
    ListaRoles: 'Roles',
    ActualizaRol: `Roles/update`,
    ListaCadenas: 'Chain',
    ListaUsuarios: 'Usuarios',
    updateUsuario: 'Usuarios/update',
    deleteUser: (id) => `Usuarios/delete/${id}`,
    ListaDmeLog: 'dme/log',             // GET con filtros (fecha, cadena, paginaci�n)
    DetalleDmeLog: (id) => `dme/log/${id}`, // GET detalle por ReturnId
    ChainMailsList: 'DmeChainConfig/GetMails', // GET
    ChainMailsAdd: 'DmeChainConfig/AddMail',   // POST { chain, email }
    ChainMailsDel: 'DmeChainConfig/DeleteMail',        // DELETE
    ChainSetLimit: 'DmeChainConfig/SetAmountLimit',   // POST { chain, email }
    ChainGetLimit: 'DmeChainConfig/ChainGetLimit',
};
